<!--
  SupportPriorityBadge.svelte — a ticket's priority as a badge.

  Only `high` and `urgent` are allowed colour that competes with the status
  badge beside them; the everyday priorities stay quiet so a queue full of
  normal tickets does not read as a wall of alarms.
-->
<script lang="ts">
	import { Badge } from 'flowbite-svelte';
	import type { SupportTicketPriority } from '../AppTypes';
	import { SUPPORT_PRIORITY_COLORS, supportPriorityLabel } from '../support/supportFormat';
	import { t } from '../i18n';

	interface Props {
		/** The priority to show. */
		priority: SupportTicketPriority;
		/** Extra classes for the badge. */
		class?: string;
	}

	let { priority, class: className = '' }: Props = $props();
</script>

<Badge color={SUPPORT_PRIORITY_COLORS[priority] ?? 'gray'} class="whitespace-nowrap {className}">
	{#if priority === 'urgent'}<i class="fa-solid fa-bolt me-1"></i>{/if}{$t(supportPriorityLabel(priority))}
</Badge>
